import { render, staticRenderFns } from "./UploadFiles4.vue?vue&type=template&id=61a10c0e&scoped=true"
import script from "./UploadFiles4.vue?vue&type=script&lang=js"
export * from "./UploadFiles4.vue?vue&type=script&lang=js"
import style1 from "./UploadFiles4.vue?vue&type=style&index=1&id=61a10c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a10c0e",
  null
  
)

export default component.exports